// PublicRoute.js
import React from 'react'
import { Route, Redirect } from 'react-router-dom'

const PublicRoute = ({ component: Component, restricted = false, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      const hasSession = !!localStorage.getItem('dfp/session')
      if (hasSession && restricted) {
        Object.keys(localStorage)
          .filter(key => key.startsWith('dfp/'))
          .forEach(key => localStorage.removeItem(key))
        return <Component {...props} />
      }
      if (hasSession && !restricted) {
        return (
          <Redirect
            to={{
              pathname: '/property-data',
              search: props.location.search
            }}
          />
        )
      }
      return <Component {...props} />
    }}
  />
)

export default PublicRoute
